import { render, staticRenderFns } from "./ChangeDefaultCard.vue?vue&type=template&id=ffc8fb92&"
import script from "./ChangeDefaultCard.vue?vue&type=script&lang=js&"
export * from "./ChangeDefaultCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports